import { reducers, getState } from 'redux/core'
import actions from 'redux/actions'

/**
 * Fetches subscription plans
 *
 * @returns {Promise} request
 */
const fetchPlans = () =>
  actions.models.subscription.fetchPlans()
    .then((plansByGroups) => {
      const { models: { subscription: { currPlan: { name: planName } } } } = getState()

      plansByGroups.some(({ plans }, scentIndex) =>
        plans.some(({ name }, monthIndex) => {
          const isFound = name === planName

          if (isFound) {
            reducers.models.upgradeSubscriptionFlow.update({
              currScentIndex: scentIndex,
              currMonthIndex: monthIndex,
              activeScentIndex: scentIndex,
              activeMonthIndex: monthIndex,
            })
          }

          return isFound
        })
      )
    })

/**
 * Sets active scent index
 *
 * @param {number} index
 */
const setActiveScentIndex = (index) => reducers.models.upgradeSubscriptionFlow.update({
  activeScentIndex: index,
  activeMonthIndex: null,
})

/**
 * Sets active month index
 *
 * @param {number} index
 */
const setActiveMonthIndex = (index) => reducers.models.upgradeSubscriptionFlow.setActiveMonthIndex(index)

/**
 * Returns user selected plan
 *
 * @returns {{
 *   name:string,
 *   scentCount:number,
 *   monthCount:number,
 *   shippingPeriod:number,
 *   productPrice:number
 *   totalPrice:number,
 * }} plan
 */
const getSelectedPlan = (state) => {
  const {
    models: {
      subscription: { plans },
      upgradeSubscriptionFlow: { activeScentIndex, activeMonthIndex },
    },
  } = state

  if (typeof activeScentIndex === 'number' && typeof activeMonthIndex === 'number' && plans[activeScentIndex]) {
    return plans[activeScentIndex].plans[activeMonthIndex]
  }

  return null
}

/**
 * Sets current step name
 *
 * @param {string} stepName
 */
const setCurrStep = (stepName) => reducers.models.upgradeSubscriptionFlow.setCurrStep(stepName)


export default {
  fetchPlans,
  setActiveScentIndex,
  setActiveMonthIndex,
  getSelectedPlan,
  setCurrStep,
}
